const Auth = (props: any) => {
    return (<div>
        <h4>Landing Page</h4>
        <p>Work in progress</p>
    </div>)
}

export default Auth;